module.exports = __webpack_public_path__ + "media/images/app/benefits/style-8e57ff4f2f64ae17d7301a92449da677.webp";